// ============================================================
// TERROR ENGINE — SPRITE MANIFEST
// Every player and companion sprite URL, defined once.
// All zones import from here. Add a new frame? Add it here.
// _b walk frames disabled for now — all point to _a.
// When walk animation is ready: swap _b entries to real files.
// ============================================================

import { CDN } from "./CDN";

// ── Player sprites ────────────────────────────────────────────
export const PLAYER_SPRITES = {
  // Female — directional walk
  player_f_down_a:  `${CDN}/player_f_down_a.webp`,
  player_f_down_b:  `${CDN}/player_f_down_a.webp`,   // _b disabled
  player_f_up_a:    `${CDN}/player_f_up_a.webp`,
  player_f_up_b:    `${CDN}/player_f_up_a.webp`,     // _b disabled
  player_f_left_a:  `${CDN}/player_f_left_a.webp`,
  player_f_left_b:  `${CDN}/player_f_left_a.webp`,   // _b disabled
  player_f_right_a: `${CDN}/player_f_right_a.webp`,
  player_f_right_b: `${CDN}/player_f_right_a.webp`,  // _b disabled
  // Female — idle / bored / front
  // ⚠⚠ 2026-09-13: EVERY idle/front/bored file 404s on terror-assets
  // (checked with curl: player_f_front_a, player_f_idle_a, player_f_idle_b,
  // player_f_bored_a, player_m_idle_a — only the four walk directions and
  // jynxi exist). A player standing still therefore had NO BODY on the pier
  // — the white figure left on screen was the companion — and the idle
  // frame retried every 1.7s, which was the console's flood of 404s.
  // They alias the walk-down frame until the idle art is uploaded; when it
  // is, restore these five paths and nothing else changes.
  player_f_front_a: `${CDN}/player_f_down_a.webp`,
  player_f_idle_a:  `${CDN}/player_f_down_a.webp`,
  player_f_idle_b:  `${CDN}/player_f_down_a.webp`,
  player_f_bored_a: `${CDN}/player_f_down_a.webp`,
  player_f_default: `${CDN}/player_f_down_a.webp`,

  // Male — directional walk
  player_m_down_a:  `${CDN}/player_m_down_a.webp`,
  player_m_down_b:  `${CDN}/player_m_down_a.webp`,   // _b disabled
  player_m_up_a:    `${CDN}/player_m_up_a.webp`,
  player_m_up_b:    `${CDN}/player_m_up_a.webp`,     // _b disabled
  player_m_left_a:  `${CDN}/player_m_left_a.webp`,
  player_m_left_b:  `${CDN}/player_m_left_a.webp`,   // _b disabled
  player_m_right_a: `${CDN}/player_m_right_a.webp`,
  player_m_right_b: `${CDN}/player_m_right_a.webp`,  // _b disabled
  // Male — idle / bored / front (one frame — reuse _a)
  // ⚠ player_m_idle_a.webp 404s too (see the female block) — walk-down frame
  player_m_front_a: `${CDN}/player_m_down_a.webp`,
  player_m_idle_a:  `${CDN}/player_m_down_a.webp`,
  player_m_idle_b:  `${CDN}/player_m_down_a.webp`,
  player_m_bored_a: `${CDN}/player_m_down_a.webp`,
  player_m_default: `${CDN}/player_m_down_a.webp`,
};

// ── Companions ────────────────────────────────────────────────
export const COMPANION_SPRITES = {
  default: `${CDN}/jynxi.webp`,
  jynxi:   `${CDN}/jynxi.webp`,
};

// ── Zone backgrounds ──────────────────────────────────────────
export const ZONE_BACKGROUNDS = {
  plaza:        `${CDN}/p_center.webp`,
  workshop:     `${CDN}/p_forge.webp`,
  faction_hall: `${CDN}/p_alliance.webp`,
};

// ── Zone NPC / rep sprites ────────────────────────────────────
export const NPC_SPRITES = {
  ser_vael: `${CDN}/p_nihil.webp`,
  calyx:    `${CDN}/p_omnia.webp`,
};

// ── Helpers ───────────────────────────────────────────────────

/**
 * Resolve directional player sprite.
 * @param {string} gender  "f" | "m"
 * @param {number} facingX -1 | 0 | 1
 * @param {number} facingY -1 | 0 | 1
 * @param {boolean} walkFrame  true = _b frame, false = _a frame
 */
export function getPlayerSprite(gender, facingX, facingY, walkFrame) {
  const g     = gender === "f" ? "f" : "m";
  const frame = walkFrame ? "b" : "a";
  let dir = "down";
  if (facingY === -1)      dir = "up";
  else if (facingY === 1)  dir = "down";
  else if (facingX === -1) dir = "left";
  else if (facingX === 1)  dir = "right";
  return (
    PLAYER_SPRITES[`player_${g}_${dir}_${frame}`] ||
    PLAYER_SPRITES[`player_${g}_${dir}_a`]        ||
    PLAYER_SPRITES[`player_${g}_default`]
  );
}

/**
 * Resolve idle sprite, gender-aware.
 * @param {string}  gender    "f" | "m"
 * @param {boolean} idleFrame true = _b (female only)
 */
export function getIdleSprite(gender, idleFrame) {
  const g = gender === "f" ? "f" : "m";
  return (
    PLAYER_SPRITES[`player_${g}_idle_${g === "f" && idleFrame ? "b" : "a"}`] ||
    PLAYER_SPRITES[`player_${g}_default`]
  );
}

/**
 * Companion sprite by id. Falls back to J'aeonxi.
 */
export function getCompanionSprite(companionId) {
  return COMPANION_SPRITES[companionId] || COMPANION_SPRITES.default;
}
